webpackJsonp([69],{

/***/ "driL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/relation-list_582b5e422b2dfc03de3622f1c50e85d9.html";

/***/ }),

/***/ "z2E9":
/***/ (function(module, exports, __webpack_require__) {

var RelationDataList = [
    {
        name: 'make-video',
        preview: 'https://assets.animatron.com/images/landing/success_stories/success_story_logo_981.png',
        description: 'wv.ss1.website',
        title: 'wv.ss1.website',
        url: 'https://www.981media.com/'
    },
    {
        name: 'mari1',
        preview: 'https://assets.animatron.com/images/landing/success_stories/mari1_preview.jpg',
        description: 'wv.ss.free-workshop',
        title: 'wv.ss2.mari1.title',
        url: 'wave/videos-for-social-media-mari-smith'
    },
    {
        name: 'fb-cover',
        preview: 'https://assets.animatron.com/images/landing/success_stories/fb-cover_preview.png',
        description: 'wv.ss.read-more',
        title: 'wv.ss2.fb-cover.title',
        url: 'https://blog.animatron.com/how-to-make-a-facebook-cover-video-in-5-easy-steps/'
    },
    {
        name: 'edit-social-video-5-steps',
        preview: 'https://assets.animatron.com/images/landing/success_stories/981_edit_videos.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.ss2.edit-social-video-5-steps',
        url: 'https://blog.animatron.com/edit-videos-for-social-media-in-5-easy-steps/'
    },
    {
        name: 'make-video-never-done-before',
        preview: 'https://assets.animatron.com/images/landing/success_stories/981-diy-video.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.ss2.diy-video',
        url: 'https://blog.animatron.com/how-to-make-a-video-if-youve-never-done-it-before-a-step-by-step-guide/'
    },
    {
        name: 'what-is-video-marketing',
        preview: 'https://assets.animatron.com/images/landing/success_stories/what-is-video-marketing.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.homestars.what-is-video-marketing',
        url: 'https://blog.animatron.com/what-is-video-marketing-and-why-does-your-company-need-it/'
    },
    {
        name: 'sm-cheat-sheet',
        preview: 'https://assets.animatron.com/images/landing/success_stories/cheat_sheet.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.homestars.sm-cheat-sheet',
        url: 'https://blog.animatron.com/social-media-cheat-sheet-for-video-ad-specs/'
    }
];
var RelationList = (function () {
    function RelationList() {
        this.list = this.list.map(function (relationName) {
            return RelationDataList.filter(function (relationItem) { return relationItem.name === relationName; })[0];
        });
    }
    return RelationList;
}());
angular.module('animatronApp.relationList', []).component('relationList', {
    bindings: {
        list: '<'
    },
    controller: RelationList,
    templateUrl: __webpack_require__("driL")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/69-28dc41a6a889e793a2e2.min.js